import { lazy } from 'react';

export const TradingJournalPageLazy = lazy(
    () => import('./trading-journal-page'),
);
